import { MotifButton, MotifCard, MotifCardBody, MotifCardFooter, MotifChip, MotifChipGroup, MotifFileUploaderItem } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationInfoWithMessage = (props: any) => {
    const { content, enabledToAnswer } = props;
    const dispatch = useDispatch();

    const clickHandler = () => {
        if(content.downloadUrl) {
            window.open(content.downloadUrl, "_self");
        }
        dispatch({ type: "CONVERSATION_MESSAGE_SEND", payload: { text: content.subtitle } })
    }
    
    return (
        <MotifCard className="!w-full">
            <MotifCardBody>
                <p className="text-md">
                    {content.title}
                </p>
            </MotifCardBody>
            <MotifCardBody className="flex justify-left">
                <MotifButton disabled={!content.downloadUrl && !enabledToAnswer} onClick={clickHandler} variant="text-alt">
                    {content.subtitle}
                </MotifButton>
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationInfoWithMessage